module.exports = __webpack_public_path__ + "assets/plant-level-1.2549e8bf.svg";